import { render, staticRenderFns } from "./SelectRejectReasonInstantClaim.vue?vue&type=template&id=3cde691a&"
import script from "./SelectRejectReasonInstantClaim.vue?vue&type=script&lang=js&"
export * from "./SelectRejectReasonInstantClaim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports